/**
 * Returns true when a TimeTracker report wrapper has no employee records.
 * @param {Object} data - Report data wrapper with a `data` property
 * @returns {boolean}
 */
export const isTimeTrackerReportEmpty = data =>
  Object.keys(data?.data || {}).length === 0;

/**
 * Returns true when a flat report data object has no employee records (PDF exports).
 * @param {Object} data - Flat report data (employeeId -> reportObject)
 * @returns {boolean}
 */
export const isTimeTrackerFlatReportEmpty = data => Object.keys(data || {}).length === 0;
